import type { CSSProperties } from 'react';

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

const stripNumericKeys = (styleObject: Record<string, unknown>): CSSProperties => {
  const normalized: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(styleObject)) {
    if (/^\d+$/.test(key)) {
      continue;
    }

    normalized[key] = value;
  }

  return normalized as CSSProperties;
};

export const normalizeStyle = (style: unknown): CSSProperties => {
  if (Array.isArray(style)) {
    return style.reduce<CSSProperties>((accumulator, item) => {
      if (!isPlainObject(item)) {
        return accumulator;
      }

      Object.assign(accumulator, stripNumericKeys(item));
      return accumulator;
    }, {});
  }

  if (!isPlainObject(style)) {
    return {};
  }

  return stripNumericKeys(style);
};
